/**
 * MODULE: domain/pages/frontend/utils/pagesCalloutUtils.ts
 * PURPOSE: Callout block variant labels and Tailwind class maps
 */

export type CalloutVariant = 'info' | 'warning' | 'success' | 'neutral';

export const CALLOUT_VARIANTS: CalloutVariant[] = ['info', 'warning', 'success', 'neutral'];

export function normalizeCalloutVariant(raw: unknown): CalloutVariant {
  const value = String(raw ?? 'info').toLowerCase();
  if (value === 'warning' || value === 'success' || value === 'neutral') {
    return value;
  }
  return 'info';
}

export function calloutVariantLabel(variant: CalloutVariant): string {
  switch (variant) {
    case 'warning':
      return 'Warning';
    case 'success':
      return 'Success';
    case 'neutral':
      return 'Note';
    default:
      return 'Info';
  }
}

export function calloutVariantClasses(variant: CalloutVariant): string {
  switch (variant) {
    case 'warning':
      return 'border-amber-300 bg-amber-50 text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100';
    case 'success':
      return 'border-emerald-300 bg-emerald-50 text-emerald-950 dark:border-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-100';
    case 'neutral':
      return 'border-gray-300 bg-gray-50 text-gray-900 dark:border-gray-600 dark:bg-gray-900/60 dark:text-gray-100';
    default:
      return 'border-blue-300 bg-blue-50 text-blue-950 dark:border-blue-800 dark:bg-blue-950/40 dark:text-blue-100';
  }
}
